import {NgModule} from '@angular/core'
import {ButtonModule} from '../button/button.module'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'
import {BottomNavigationComponent} from './bottom-navigation.component'
import {ContactBottomNavigationComponent} from './contact-bottom-navigation/contact-bottom-navigation.component'
import {CommonModule} from '@angular/common'

@NgModule({
  declarations: [BottomNavigationComponent, ContactBottomNavigationComponent],
  imports: [CommonModule, ButtonModule, FontAwesomeModule],
  exports: [BottomNavigationComponent, ContactBottomNavigationComponent],
})
export class BottomNavigationModule {}
